import Reveal from "@/components/Reveal";
import Monogram from "@/components/Monogram";

export default function Contact() {
  return (
    <>
      <section className="pt-44 pb-16 px-6 lg:px-14 bg-[#F5F2ED] relative overflow-hidden">
        <Monogram size={620} opacity={0.05} color="#4A3E39" className="absolute -right-40 -top-20 hidden md:block" />
        <div className="max-w-[1500px] mx-auto">
          <Reveal>
            <div className="eyebrow mb-6">Contact</div>
            <h1 className="font-display font-light text-ivory-800 text-6xl md:text-8xl lg:text-[120px] leading-[0.95] max-w-5xl">
              Write to <em className="italic">us</em>.
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="px-6 lg:px-14 py-20 lg:py-32 bg-[#F5F2ED]">
        <div className="max-w-[1500px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-24">
          <div className="lg:col-span-7 space-y-12">
            {[
              { t: "Atelier", b: "14, Pali Hill Road\nBandra West, Mumbai 400050" },
              { t: "Hours", b: "Tuesday — Saturday · 10–8\nSunday · 11–6\nMonday · Closed" },
              { t: "Bookings & Enquiries", b: "hello@tsivory.com\n+91 22 4040 8080" },
              { t: "Press & Bridal", b: "press@tsivory.com" },
            ].map((c) => (
              <Reveal key={c.t}>
                <div className="border-b border-[#B7AB9B]/60 pb-8">
                  <div className="eyebrow mb-4">{c.t}</div>
                  <p className="font-display text-ivory-800 text-2xl md:text-3xl whitespace-pre-line leading-snug">{c.b}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal className="lg:col-span-5" delay={120}>
            <div className="zoom-wrap aspect-[4/5] overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1774477178005-bff823e43be8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxuZXV0cmFsJTIwaW50ZXJpb3IlMjBtaW5pbWFsJTIwc3VubGlnaHR8ZW58MHx8fHwxNzgyMTE1ODg5fDA&ixlib=rb-4.1.0&q=85"
                alt="Inside the atelier"
                className="zoom-img w-full h-full object-cover"
              />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
